export default __webpack_public_path__ + "static/media/ZZBX-logo.b9903089.gif";